import { WEB_COMPONENT_INTEGRATION_INFORMATION } from '../../webcomponents.constants';
import { IntegrationInformationWebComponent } from './component/IntegrationInformationWebComponent';

export { IntegrationInformationWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRATION_INFORMATION, IntegrationInformationWebComponent);
